import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import CustomizationForm from "../components/CustomizationForm";
import ContactFloat from "@/components/ContactFloat";

export default function SchemeCustomization() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("scheme.title")}</title>
        <meta name="keywords" content={t("scheme.keywords")} />
        <meta name="description" content={t("scheme.description")} />
      </Helmet>
      <ContactFloat />
      {/* Banner */}
      <div className="bg-[#10549a]">
        <div className="w-full h-[400px]">
          <div
            className="w-full h-[400px] bg-[url('/images/schemeCustomization_01.jpg')] bg-no-repeat bg-center relative"
            data-aos="fade-right"
            data-aos-offset="100"
            data-aos-duration="500"
          >
            <div className="w-1200 mx-auto">
              <div className="text-center text-[30px] font-bold text-white pt-[150px] relative">
                <h2
                  className="relative pb-[25px] text-[30px]"
                  data-aos="fade-right"
                  data-aos-offset="100"
                  data-aos-duration="500"
                >
                  {t("scheme.banner.title")}
                  <i
                    className="absolute left-1/2 bottom-0 h-[4px] w-[50px] bg-white -ml-[30px]"
                    data-aos-delay="300"
                    data-aos="zoom-in"
                  ></i>
                </h2>
                <p
                  className="pt-5 text-[18px]"
                  data-aos="fade-left"
                  data-aos-offset="100"
                  data-aos-duration="500"
                >
                  {t("scheme.banner.subtitle")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Form Section */}
      <div className="relative w-full bg-[#f2f4f6] pt-[60px]">
        <div className="w-1200 mx-auto">
          <h2
            className="font-bold text-[#222] text-[34px] text-center pb-5"
            data-aos-delay="100"
            data-aos="fade-up"
          >
            {t("scheme.form.title")}
          </h2>

          <div
            className="border-t border-[#ddd] py-[50px] mt-[50px] text-center"
            data-aos="fade-up"
            data-aos-anchor-placement="top-bottom"
          >
            <p className="leading-[30px] text-[#666] text-sm">
              {t("scheme.form.intro.p1")}
            </p>
            <p className="leading-[30px] text-[#666] text-sm">
              {t("scheme.form.intro.p2")}
            </p>
          </div>

          <CustomizationForm />
        </div>
      </div>
    </>
  );
}
